// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"3":"8bd2ba67","372":"3f7a357f","443":"e7f46fdd","738":"52a52d4f","787":"2b7e62db","856":"9b2c47a2"}[chunkId] + ".chunk.js";
};